import styled from "styled-components";
import CustomButton from "../../../../components/CustomButton";

export const FilterButton = styled.button`
  display: none; 

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: inline-flex; 
    width: auto;
    min-width: 120px;
    padding: 12px 16px;
    margin: 0;
    background-color: ${({ theme }) => theme.palette.primary.blue500};
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-family: inherit;
    line-height: 1;
    white-space: nowrap;
    font-size: ${10 / 16}rem;
    height: 38px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

    &:hover {
      background-color: hsl(17, 71%, 45%);
      transform: translateY(-1px);
    }

    &::after {
      content: "+";
      font-size: ${16 / 16}rem;
      margin-left: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 12px 16px;
    width: 100px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${14 / 16}rem;
    height: 44px;
    padding: 2px 16px;
    width: 140px;
  }
`;


export const StyledCustomButton = styled(CustomButton)`
  display: none; 

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex; 
    border-radius: 32px;
    padding: 8px;
    height: 6vh;
    white-space: nowrap;
    width: 16vw;
    font-size: ${12/16}rem; 
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    display: flex; 
    border-radius: 32px;
    padding: 8px;
    height: 6vh;
    width: 16vw;
    white-space: nowrap;
  }

  @media (min-width: ${({ theme }): any => theme.breakpoints.desktop}) {
    display: flex; 
    border-radius: 32px;
    padding: 8px;
    height: 6vh;
    width: 10vw;
    font-size: ${12/16}rem; 
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${14/16}rem; 
  }

  @media (min-width: ${({ theme }) => theme.breakpoints. desktopTxl}) {
    font-size: ${16/16}rem; 
  }
`;

export const Wrapper = styled.div`
  margin: 24px 0;
  font-family: "Inter", sans-serif;
  color: ${({ theme }) => theme.palette.primary.blue900};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0;
  }
`;

export const Title = styled.h6`
  font-weight: 700;
  font-size: ${24 / 16}rem;
`;

export const PropertyQuantity = styled.p`
  font-weight: 500;
  font-size: ${16 / 16}rem;
  margin-top: 8px;
`;

export const InputFilterWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  width: 100%;
  position: relative;

  > button {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    justify-content: space-between;
    > button {
      max-width: ${167 / 16}rem;
      
      display: flex;  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
        height: 2vh;
        .more-filters-button {
          margin-left: auto; 
          }
        }

      display: flex;  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
        height: 2vh;
        .more-filters-button {
          margin-left: auto; 
          }
        }
      }
  }`;

export const FiltersNumberIndicator = styled.div`
  width: 24px;
  height: 24px;
  display: none;
  padding: 4px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  right: 8px;
  top: -12px;
  color: #fff;
  font-family: sans-serif;
  background-color: ${({ theme }) => theme.palette.secondary.orange500};
  font-size: ${14 / 16}rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
  }
`;
